<!-- eslint-disable max-len -->
<template>
<svg
    id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 63.1 63.1"
>
    <path
        d="M48.3,34.8c1.8-1.8,1.8-4.6,0-6.4l-27-27c-1.8-1.8-4.6-1.8-6.5-0.1c-1.8,1.8-1.8,4.6,0,6.4l23.8,23.8L14.9,55.4c-1.8,1.8-1.8,4.6,0,6.4s4.6,1.8,6.4,0L48.3,34.8L48.3,34.8z" fill="currentColor"
    />
</svg>
</template>
